import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const PaymentGatewaySelector = ({ onSelect, selectedGateway }) => {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActiveGateways();
  }, []);

  const fetchActiveGateways = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/payment-gateways/active`);
      setGateways(response.data.gateways || []);
    } catch (error) {
      console.error('Error fetching gateways:', error);
      setGateways([]);
    } finally {
      setLoading(false);
    }
  };

  const getGatewayIcon = (type) => {
    const icons = {
      payu: '💳',
      icici: '🏦',
      idfc: '🏛️',
      razorpay: '⚡',
      phonepe: '📱',
      'phonepe-tsp': '📱',
      phonepe_tsp: '📱'
    };
    return icons[type] || '💳';
  };

  const getGatewayDescription = (type) => {
    const descriptions = {
      payu: 'Credit/Debit Cards, Net Banking, UPI',
      icici: 'ICICI Bank Gateway - All payment methods',
      idfc: 'IDFC Bank Gateway - Secure payments',
      razorpay: 'UPI, Cards, Wallets, Net Banking',
      phonepe: 'UPI, Cards, Net Banking - PhonePe Secure',
      'phonepe-tsp': 'UPI, Cards, Net Banking - PhonePe Secure',
      phonepe_tsp: 'UPI, Cards, Net Banking - PhonePe Secure'
    };
    return descriptions[type] || 'Secure payment processing';
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="text-gray-500">Loading payment options...</div>
      </div>
    );
  }

  if (gateways.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="text-gray-500 mb-2">No payment gateways available</div>
        <div className="text-sm text-gray-400">Please contact support</div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Choose Payment Method</h3>
      {gateways.map(gateway => (
        <div
          key={gateway._id}
          onClick={() => onSelect(gateway)}
          className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
            selectedGateway?._id === gateway._id
              ? 'border-blue-500 bg-blue-50 shadow-md'
              : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="text-2xl">{getGatewayIcon(gateway.type)}</div>
              <div>
                <div className="font-semibold text-gray-900">{gateway.name}</div>
                <div className="text-sm text-gray-600">{getGatewayDescription(gateway.type)}</div>
              </div>
            </div>
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
              selectedGateway?._id === gateway._id
                ? 'border-blue-500 bg-blue-500'
                : 'border-gray-300'
            }`}>
              {selectedGateway?._id === gateway._id && (
                <div className="w-2 h-2 bg-white rounded-full"></div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentGatewaySelector;